// src/Components/ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = ({ redirectPath = "/user/login" }) => {
  const token = Cookies.get("token");
  
  if (!token) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;